const Footer = () => {
  return (
    <footer className="bg-rose-50 text-gray-800 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Über mich */}
          <div>
            <h3 className="text-xl font-playfair font-semibold mb-4 text-gray-900">
              Love yourself beauty
            </h3>
            <p className="text-gray-600 mb-4 text-sm leading-relaxed">
              Ihr Beauty-Studio im LunaCenter Wilhelmsburg. Wir bieten professionelle Kosmetikbehandlungen in entspannter Atmosphäre.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/love_yourself_beauty_by_meltem/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white rounded-full hover:bg-rose-400 hover:text-white transition-all duration-300 cursor-pointer shadow-md"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Schnelllinks */}
          <div>
            <h3 className="text-xl font-playfair font-semibold mb-4 text-gray-900">
              Schnelllinks
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="#home" className="text-gray-600 hover:text-rose-400 transition-colors cursor-pointer">
                  Home
                </a>
              </li>
              <li>
                <a href="#uber-uns" className="text-gray-600 hover:text-rose-400 transition-colors cursor-pointer">
                  Über mich
                </a>
              </li>
              <li>
                <a href="#leistungen" className="text-gray-600 hover:text-rose-400 transition-colors cursor-pointer">
                  Leistungen
                </a>
              </li>
              <li>
                <a href="#preise" className="text-gray-600 hover:text-rose-400 transition-colors cursor-pointer">
                  Preise
                </a>
              </li>
              <li>
                <a href="#galerie" className="text-gray-600 hover:text-rose-400 transition-colors cursor-pointer">
                  Galerie
                </a>
              </li>
              <li>
                <a href="#kontakt" className="text-gray-600 hover:text-rose-400 transition-colors cursor-pointer">
                  Kontakt
                </a>
              </li>
            </ul>
          </div>

          {/* Kontakt */}
          <div>
            <h3 className="text-xl font-playfair font-semibold mb-4 text-gray-900">
              Kontakt
            </h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-rose-400 mt-1 mr-3"></i>
                <span className="text-gray-600">
                  LunaCenter<br />
                  Wilhelm-Strauß-Weg 2B<br />
                  21109 Hamburg
                </span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line text-rose-400 mr-3"></i>
                <a href="tel:04052479472" className="text-gray-600 hover:text-rose-400 transition-colors whitespace-nowrap">
                  (040) 524 794 72
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line text-rose-400 mr-3"></i>
                <a href="tel:+491625676111" className="text-gray-600 hover:text-rose-400 transition-colors whitespace-nowrap">
                  +49 (0)162 567 6111
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line text-rose-400 mr-3"></i>
                <a href="mailto:mail@loveyourselfbeauty.de" className="text-gray-600 hover:text-rose-400 transition-colors">
                  mail@loveyourselfbeauty.de
                </a>
              </li>
            </ul>
          </div>

          {/* Öffnungszeiten */}
          <div>
            <h3 className="text-xl font-playfair font-semibold mb-4 text-gray-900">
              Öffnungszeiten
            </h3>
            <ul className="space-y-3 text-sm">
              <li className="flex justify-between">
                <span className="text-gray-600">Montag - Samstag:</span>
                <span className="text-gray-900 font-medium">10:00 - 18:00 Uhr</span>
              </li>
              <li className="text-gray-500 text-xs italic">
                (nach Terminvereinbarung)
              </li>
              <li className="flex justify-between">
                <span className="text-gray-600">Sonntag:</span>
                <span className="text-gray-900 font-medium">Geschlossen</span>
              </li>
            </ul>
            <div className="mt-6">
              <a
                href="#kontakt"
                className="inline-block bg-rose-400 text-white px-6 py-3 rounded-lg hover:bg-rose-500 transition-all duration-300 text-sm font-medium shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
              >
                <i className="ri-calendar-line mr-2"></i>
                Termin buchen
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-rose-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-600 text-sm text-center md:text-left">
              © 2025 Love yourself beauty by Meltem. Alle Rechte vorbehalten.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="/datenschutz" className="text-gray-600 hover:text-rose-400 transition-colors cursor-pointer">
                Datenschutz
              </a>
              <a href="/impressum" className="text-gray-600 hover:text-rose-400 transition-colors cursor-pointer">
                Impressum
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;